<template>
  <form novalidate @submit.prevent="debounceSearch">
    <div class="columns my-0">
      <div class="column is-5">
        <kst-input load-on-focus floating-label
          field="Search" :data="searchData" :catalog="SearchCatalog"
          @input="handleInput"
        />
      </div>
      <div class="column is-narrow">
        <kst-input floating-label
          field="StockID" :data="searchData" :catalog="SearchCatalog"
          :options="stockOptions" @input="handleInput"
        />
      </div>

      <div class="column is-narrow">
        <kst-button reset-mode @click="handleReset"/>
      </div>
    </div>
  </form>
</template>

<script>
import SearchCatalog from "./DSPSearchCatalog.js";
import SearchMixin from "@/mixins/SearchMixin.js";

export default {
  mixins: [SearchMixin],
  props: {
    searchData: Object,
    stockOptions: Object
  },
  data: () => ({
    SearchCatalog: SearchCatalog
  }),
  created() {
    this.initSearch(this.searchData, this.submit);
  },
  methods: {
    handleInput() {
      this.handleSearch();
    },
    submit() {
      this.$emit(this.$kst.Enum.Event.Submit);
    },
    handleReset() {
      this.$emit(this.$kst.Enum.Event.Reset);
    }
  }
}
</script>